<!--ADD ASSOCIATION MODAL STARTS-->
<app-modal [modalId]="'add-association'" [modalContentId]="'addAssoContent'" [showCloseAlert]="form.dirty"
  [showDoneBtn]="true" [modalSize]="'big'" (closeEvent)="onCancel();closeModal();">
  <modal-div class="title-text">
    View Association
  </modal-div>

  <modal-div class="body-content">
    <p class="mt-3">Fields marked with an asterisk (<span class="mandatory">*</span>) are required.
    </p>
    <p class="modal--info-txt font-bold" id="addAssoContent">You are adding associations for the following node.</p>
    <div class="jumbotron mx-0 row align-items-top justify-content-between align-items-start" *ngIf="associationNode">
      <div class="d-flex col-10" id="containerAddingAssociations">
        <p class="col-max-1 text-wrapped font-bold mb-0">{{ associationNode.human_coding_scheme }}</p>
        <p class="col-11 text-wrapped mb-0" [innerHtml]="associationNode.full_statement"></p>
      </div>
      <div class="node-navigate col-auto d-flex justify-content-between align-items-start custom-icon-size" *ngIf="showNavigation">
        <button class="btn btn-clear tooltip top font-1x position-relative" [attr.aria-label]="'Previous node'"
          data-tooltip="Previous node" [disabled]="(associationNode?.id === firstItemNode?.id)"
          (click)="onTreeNavigatePreviousClick()">
          <em class="material-icons-outlined font-4x button-icon" aria-hidden="true">west</em>
        </button>

        <button class="btn btn-clear tooltip top font-1x position-relative custom-icon-size" [attr.aria-label]="'Next node'"
          data-tooltip="Next node" [disabled]="(associationNode?.id === lastNode?.id)"
          (click)="onTreeNavigateNextClick()">
          <em class="material-icons-outlined font-4x button-icon" aria-hidden="true">east</em>
        </button>

        <span class="preview-panel--nav-helper text-uppercase text-center">navigate</span>
      </div>
    </div>
    <section class="container-fluid position-relative">
      <ng-container *ngIf="nodeLoading">
        <div class="position-absolute w-100 h-100 assciation-overlay d-block"></div>
        <app-preloader *ngIf="nodeLoading" [loaderText]="'Loading node'"
          class="w-100 position-fixed preloader-backdrop"></app-preloader>

      </ng-container>

      <section class="row justify-content-between">
        <section class="col-md-7 ">
          <form [formGroup]="form">
            <div class="row">
              <div class="dropdown form-group col-lg-6">
                <app-auto-complete [listingObj]="associationTypes"
                  (selectedObject)="selectedAssociationType=$event;onTypeSelected($event)" [selectType]="selectType"
                  [uniqueId]="'type_id'" [propName]="'display_name'" [autoCompleteTitle]="'Association Type'"
                  #autoCompleteAsso>
                </app-auto-complete>
                <p id="associationTypeHelp" class="form-text text-muted text-right">Select the association type that
                  you'd
                  want to make.</p>
              </div>
              <div class="dropdown form-group col-lg-6">
                <app-auto-complete [listingObj]="taxonomyList" (selectedObject)="updateSelectedObject($event)"
                  [selectType]="selectType" [uniqueId]="uniqueId" [propName]="'title'"
                  [autoCompleteTitle]="autoCompleteTitle" #autoCompleteTaxo>
                </app-auto-complete>
                <p id="associatedtaxonomyHelp" class="form-text text-muted text-right">Taxonomy with you'd want to
                  associate
                  this node.</p>
              </div>
            </div>
            <div class="jumbotron jumbotron-thin mx-0 mb-3">
              <div class="d-flex col-12">
                <p class="mb-0">Did you know! This node has {{associationList.length}} associations <button
                    class="btn btn-clear text-link text-underline" data-toggle="modal"
                    data-target="#viewAssociationlist" (click)="onCancel(); removeBackdrop();">View all
                    associations<span class="sr-only">Opens in a new dialog</span></button></p>
              </div>
            </div>
            <div class="form-group">
              <label for="associationDescription" class="font-bold">Association Detail</label>
              <input class="form-control" id="associationDescription" [(ngModel)]="description"
                formControlName="form_description" />
            </div>
            <div class="form-group">
              <label for="accordion" class="font-bold" id="associatedNodeLabel">Select Node(s) for Association
                <span class="mandatory">*</span></label>

              <!--Taxonomy Tree START -->
              <div class="preview-box" aria-required="true" aria-labelledby="associatedNodeLabel associatedNodeHelp">
                <section id="accordion" class="col-12 pr-0" *ngIf="taxonomyData">

                  <app-tree #tree [treeNodes]="taxonomyData.children" [viewLocation]="'taxonomydetail'"
                    [showComplaince]="false">
                  </app-tree>

                  <app-preloader *ngIf="!dataloaded" [loaderText]="'Loading Data..'"
                    class="w-100 position-fixed preloader-backdrop">
                  </app-preloader>

                </section>
              </div>
              <!--Taxonomy Tree END -->

              <p id="associatedNodeHelp" class="form-text text-muted text-right">Node that you'd want to make
                association
                with.
              </p>

            </div>

          </form>
          <p class="mt-4 mb-0"><button type="button" class="btn btn-primary"
              [disabled]="(formValid===false) || (associationNode?.is_document === 1)" id="addAssociationBtn"
              (click)="onCreateAssociation()">Add Association</button></p>
        </section>
        <aside class="col-md-4 file-panel">

          <div class="row">
            <div class="col-12 file-panel-header">
              <h3 class="mb-0 font-bold">Associations</h3>
            </div>
            <div *ngIf="showText" class="d-flex col-12 exemplar-listing">
              <div class="col-12 text-wrapped px-0 animate__animated animate__fadeIn animate__delay-2s">
                <p class="title font-bold mb-0">{{listEnding.title}}</p>
              </div>
            </div>
            <div class="d-flex col-12 exemplar-listing" *ngFor="let item of associationList ; let $index=index ">

              <div class="col-11 px-0 text-wrapped" *ngIf="item">
                <p class="title font-bold mb-0">
                  {{item.association_type_name ? item.association_type_name : item.association_type.display_name}}
                </p>
                <p class="mb-0"
                  *ngIf="item && item.destination_node && item.destination_node.document && item.destination_node.document.document_title">
                  {{item.destination_node.document.document_title}}</p>
                <p class="mb-0">{{item.title ? item.title : item.destination_node.full_statement}}</p>
              </div>
              <div class="col-1 px-0 text-right">
                <button type="button" class="btn btn-icon tooltip top position-relative d-inline-block custom-icon-size"
                  data-tooltip="Delete Association" id="deleteAssociationBtn_{{$index}}"
                  (click)="deleteAssociation(item)" [attr.aria-label]="'Delete Association'">
                  <em class="material-icons-outlined font-4x" aria-hidden="true">delete</em>
                </button>
              </div>
            </div>

          </div>


        </aside>
      </section>
    </section>
  </modal-div>

</app-modal>
<!--ADD ASSOCIATION MODAL ENDS-->


<!--VIEW ALL ASSOCIATION MODAL STARTS-->
<app-modal [modalId]="'viewAssociationlist'" [modalContentId]="'viewAssociationlistContent'" [modalSize]="'big'"
  (closeEvent)="onCancel()">
  <modal-div class="title-text">
    View Association
  </modal-div>

  <modal-div class="body-content">
    <p class="modal--info-txt font-bold" id="viewAssociationlistContent">Here is a list of associations between Taxonomy
      Name 1 and Taxonomy Name 2.</p>

    <section class="container-fluid">
      <app-data-table [showMenu]="false" class="w-100" [columnList]="listOfColumn" [tableCategory]="'association'"
        [dataSet]="associationData" [uniqueField]="'document_id'">
      </app-data-table>
    </section>
  </modal-div>
</app-modal>
<!--VIEW ALL ASSOCIATION MODAL ENDS-->
